import React from 'react';
import { Button } from './ui/Button';
import { ArrowLeftIcon } from 'lucide-react';
export function Terms() {
  return <section className="py-16 bg-white" data-id="element-458">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-459">
        <div className="max-w-4xl mx-auto" data-id="element-460">
          <div className="mb-10 flex items-center" data-id="element-461">
            <Button variant="ghost" className="mr-4" href="/" data-id="element-462">
              <ArrowLeftIcon className="mr-2" size={16} data-id="element-463" />
              Back to home
            </Button>
          </div>
          <div className="border-2 border-[#0A4D8C] rounded-xl p-8 shadow-md bg-white" data-id="element-464">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-465">
              Terms and Conditions – Nexio App
            </h1>
            <div className="bg-gray-50 px-4 py-2 rounded-lg inline-block mb-6" data-id="element-466">
              <p className="text-gray-600" data-id="element-467">Effective Date: 01-10-2025</p>
            </div>
            <div className="prose max-w-none text-gray-700" data-id="element-468">
              <p className="mb-6" data-id="element-469">
                Welcome to Nexio App. These Terms and Conditions ("Terms")
                govern your use of our services. By creating an account,
                subscribing, or using Nexio App, you agree to these Terms.
              </p>
              <p className="mb-6" data-id="element-470">
                If you do not agree, please do not use our services.
              </p>
              <h2 className="text-xl font-bold text-[#0A4D8C] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-471">
                1. Definitions
              </h2>
              <ul className="space-y-2 mb-6" data-id="element-472">
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-473">
                  <span className="font-medium" data-id="element-474">"We," "Us," "Our"</span> –
                  refers to Nexio App.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-475">
                  <span className="font-medium" data-id="element-476">"User," "You"</span> – any
                  individual or company using Nexio App.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-477">
                  <span className="font-medium" data-id="element-478">"Service"</span> – the Nexio App
                  platform, tools, and related features.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-479">
                  <span className="font-medium" data-id="element-480">"Subscription"</span> – paid
                  access to Nexio App services, either monthly or yearly.
                </li>
              </ul>
              <h2 className="text-xl font-bold text-[#0A4D8C] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-481">
                2. Eligibility
              </h2>
              <p className="mb-4" data-id="element-482">To use Nexio App, you must:</p>
              <ul className="space-y-2 mb-6" data-id="element-483">
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-484">
                  Be at least 18 years old.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-485">
                  Have the legal capacity to enter into agreements.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-486">
                  Provide accurate and complete registration information.
                </li>
              </ul>
              <h2 className="text-xl font-bold text-[#0A4D8C] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-487">
                3. Subscriptions & Payments
              </h2>
              <ul className="space-y-2 mb-6" data-id="element-488">
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-489">
                  Nexio App is offered on a subscription basis (monthly or
                  yearly).
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-490">
                  By subscribing, you agree to pay the fees displayed at the
                  time of purchase.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-491">
                  Payments are processed securely by third-party providers.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-492">
                  <span className="font-medium" data-id="element-493">Auto-Renewal:</span>{' '}
                  Subscriptions renew automatically unless canceled before the
                  renewal date.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-494">
                  <span className="font-medium" data-id="element-495">Cancellation:</span> You may
                  cancel anytime from your account settings. Access remains
                  until the end of the current billing cycle.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-496">
                  <span className="font-medium" data-id="element-497">Refunds:</span> We do not offer
                  partial refunds for unused time. Refunds may be granted only
                  where required by law.
                </li>
              </ul>
              <h2 className="text-xl font-bold text-[#0A4D8C] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-498">
                4. Free Trials
              </h2>
              <p className="mb-6" data-id="element-499">
                We may offer free trials. If you do not cancel before the trial
                ends, your subscription will automatically convert into a paid
                plan.
              </p>
              <h2 className="text-xl font-bold text-[#0A4D8C] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-500">
                5. User Responsibilities
              </h2>
              <p className="mb-4" data-id="element-501">You agree to:</p>
              <ul className="space-y-2 mb-6" data-id="element-502">
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-503">
                  Use Nexio App in compliance with these Terms and applicable
                  laws.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-504">
                  Keep your login credentials secure.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-505">
                  Not share your account with others unless allowed under your
                  plan.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-506">
                  Not misuse or attempt to disrupt the Service.
                </li>
              </ul>
              <h2 className="text-xl font-bold text-[#0A4D8C] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-507">
                6. Intellectual Property
              </h2>
              <ul className="space-y-2 mb-6" data-id="element-508">
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-509">
                  All content, software, and materials provided by Nexio App
                  remain our property.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-510">
                  You may use the Service only for its intended purpose.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-511">
                  You may not copy, modify, resell, or distribute any part of
                  Nexio App without our written consent.
                </li>
              </ul>
              <h2 className="text-xl font-bold text-[#0A4D8C] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-512">
                7. Service Availability
              </h2>
              <ul className="space-y-2 mb-6" data-id="element-513">
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-514">
                  We aim for 24/7 availability but do not guarantee
                  uninterrupted service.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-515">
                  We may suspend or limit access for maintenance, updates, or
                  security reasons.
                </li>
              </ul>
              <h2 className="text-xl font-bold text-[#0A4D8C] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-516">
                8. Limitation of Liability
              </h2>
              <ul className="space-y-2 mb-6" data-id="element-517">
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-518">
                  Nexio App is provided "as is" without warranties of any kind.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-519">
                  To the maximum extent permitted by law, we are not liable for
                  indirect, incidental, or consequential damages.
                </li>
                <li className="pl-4 border-l-2 border-[#4DD8D8]" data-id="element-520">
                  Our total liability will not exceed the amount you paid for
                  your subscription in the last 12 months.
                </li>
              </ul>
              <h2 className="text-xl font-bold text-[#0A4D8C] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-521">
                9. Termination
              </h2>
              <p className="mb-6" data-id="element-522">
                We may suspend or terminate your account if you violate these
                Terms. In such cases, no refunds will be provided.
              </p>
              <h2 className="text-xl font-bold text-[#0A4D8C] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-523">
                10. Data Protection & Privacy
              </h2>
              <p className="mb-6" data-id="element-524">
                Your personal data is handled in accordance with our Privacy
                Policy. By using Nexio App, you consent to such processing.
              </p>
              <h2 className="text-xl font-bold text-[#0A4D8C] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-525">
                11. Changes to the Terms
              </h2>
              <p className="mb-6" data-id="element-526">
                We may update these Terms from time to time. If changes are
                material, we will notify you (e.g., via email or in-app notice).
                Continued use of the Service means you accept the updated Terms.
              </p>
              <h2 className="text-xl font-bold text-[#0A4D8C] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-527">
                12. Governing Law
              </h2>
              <p className="mb-6" data-id="element-528">
                These Terms are governed by the laws of [Insert Country]. Any
                disputes shall be handled by the courts of [Insert
                Jurisdiction].
              </p>
              <h2 className="text-xl font-bold text-[#0A4D8C] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-529">
                13. Contact Us
              </h2>
              <p className="mb-6" data-id="element-530">
                For questions about these Terms, please contact:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-100 shadow-sm" data-id="element-531">
                <p className="flex items-center justify-center space-x-4" data-id="element-532">
                  <span data-id="element-533">
                    📧{' '}
                    <a href="mailto:info@nexioapp.cloud" className="text-[#0A4D8C] hover:underline" data-id="element-534">
                      info@nexioapp.cloud
                    </a>
                  </span>
                  <span data-id="element-535">
                    🌐{' '}
                    <a href="https://nexioapp.cloud" className="text-[#0A4D8C] hover:underline" data-id="element-536">
                      nexioapp.cloud
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}